import React from 'react';
import {
  Button,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import menuStyles from './menu.less';
import clsx from 'clsx';
import { useMenuStatus } from './menu';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

export function BaseMenuItem({ menu, onClick }) {


  const dispatch = useDispatch();
  const { activated, expanded, setExpanded } = useMenuStatus(menu);
  const hasChildren = menu?.children?.length > 0;
  const hasFirstAction = !!menu.firstActionPath && !!menu.children; //please inform if there's another way to do this
  const isClickable = !!menu.path || !!menu.link;
  const toggle = (e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const clickMenu = () => {
    if (!menu.path) {
      setExpanded(!expanded);
    }
    onClick(menu);
  };

  const onFirstAction = () => {
    dispatch(push(menu.firstActionPath));
  };

  return (
    <>
      <ListItem
        button
        component="a"
        className={clsx(
          menuStyles.item,
          menu.className,
          activated && menuStyles.selected,
          isClickable && menuStyles.cta
        )}
        level={menu.level || 0}
        onClick={clickMenu}
        target="_blank"
        href={menu.link}
      >
        {!!menu.icon && <ListItemIcon>{menu.icon}</ListItemIcon>}
        <ListItemText title={menu.name} primary={menu.name} />
        {(hasChildren || hasFirstAction) &&
          (expanded ? (
            <ExpandLess onClick={toggle} color="disabled" />
          ) : (
            <ExpandMore onClick={toggle} color="disabled" />
          ))}
      </ListItem>
      {(hasChildren || hasFirstAction) && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {hasChildren ? (
            <List component="div" disablePadding>
              {menu.children.map((item) => (
                <BaseMenuItem key={item.id} menu={item} onClick={onClick} />
              ))}
            </List>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <Button
                onClick={onFirstAction}
                variant="outlined"
                className={menuStyles.button}
              >
                {menu.firstAction}
              </Button>
            </div>
          )}
        </Collapse>
      )}
    </>
  );
}
